// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"jx-z","smallCardRow":"kx-z","largeCardRow":"lx-z","productSearchRow":"mx-z","curatedRow":"nx-z"};